import { useRouter } from "next/router";
import { type ReactNode, useEffect } from "react";
import {
  useGetDailyMissionListQuery,
  usePostMissionCountMutation,
} from "src/service/MissionApi";

export const PageCount = ({ children }: { children: ReactNode }): any => {
  const router = useRouter();
  const [postMissionCount] = usePostMissionCountMutation();
  const { data: dailyMission } = useGetDailyMissionListQuery();

  const PageCount = async (action: string) => {
    await postMissionCount({ actionId: action }).unwrap();
  };

  const missionComplateCheck = (action: string) => {
    return dailyMission?.data.find((item) => {
      return item.actionId === action && item.isCompleted === false;
    });
  };

  useEffect(() => {
    switch (router.pathname) {
      case "/mypage":
        if (missionComplateCheck("MYPAGE") !== undefined) {
          PageCount("MYPAGE");
          break;
        } else {
          break;
        }

      case "/other/[id]":
        if (missionComplateCheck("OTHERS_PAGE") !== undefined) {
          PageCount("OTHERS_PAGE");
          break;
        } else {
          break;
        }
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  return children;
};
